import * as THREE from "three";
import loader from "../../../../lib/texture-loader";

export default class ItemManager {
  constructor() {
    this.updaters = [
      {
        item: "cowboy_hat",
        node_names: ["Cowboy_Hat"],
        meshes: []
      },
      {
        item: "jetpack",
        node_names: ["Jetpack"],
        meshes: []
      },
      {
        item: "crown",
        node_names: ["Crown"],
        meshes: []
      },
      {
        item: "unicorn_horn",
        node_names: ["Unicorn_Horn"],
        meshes: []
      },
      {
        item: "wings",
        node_names: ["Prop_wings", "Wings", "feathers", "feathers Flip"],
        meshes: [],
        skinned: true
      }
    ];
  }

  _getMaterialFromMaps(item, skinned) {
    const material = new THREE.MeshStandardMaterial();
    const maps = [
      [item.albedo_map, "map"],
      [item.normal_map, "normalMap"],
      [item.metallic_map, "matalnessMap"],
      [item.roughness_map, "roughnessMap"],
      [item.emission_map, "emissiveMap"],
      [item.alpha_map, "alphaMap"],
      [item.ao_map, "aoMap"]
    ];

    maps.forEach(([url, mapName]) => {
      if (url) {
        if (mapName === "alphaMap") {
          material.transparent = true;
          material.side = THREE.DoubleSide;
        }

        let texture = loader.load(url);
        texture.encoding = THREE.LinearEncoding;
        texture.flipY = false;
        material[mapName] = texture;
      }
    });

    if (skinned) material.skinning = skinned;

    return material;
  }

  init(model, items) {
    this.updaters.forEach(updater => {
      const item = items.find(item => item.key === updater.item);
      if (item.albedo_map)
        updater.material = this._getMaterialFromMaps(item, updater.skinned);
    });

    model.traverse(child => {
      if (child.isMesh) {
        this.updaters.forEach(updater => {
          if (updater.node_names.includes(child.name)) {
            child.visible = false;
            updater.meshes.push(child);
            if (child.material && updater.material)
              child.material = updater.material;
          }
        });
      }
    });
  }

  hasChild(child) {
    for (let i = 0; i < this.updaters.length; i++) {
      const updater = this.updaters[i];

      for (let j = 0; j < updater.meshes.length; j++) {
        const mesh = updater.meshes[j];
        if (mesh.name.toLowerCase() === child.name.toLowerCase()) {
          return true;
        }
      }
    }
    return false;
  }

  update(pathfinder) {
    this.updaters.forEach(updater => {
      if (pathfinder.items.includes(updater.item)) {
        updater.meshes.forEach(mesh => {
          mesh.visible = true;
        });
      } else {
        updater.meshes.forEach(mesh => (mesh.visible = false));
      }
    });
  }
}
